export default __webpack_public_path__ + "static/media/4.0b9f1c73.png";